import React, { useState, useEffect } from 'react';
import './VideoBanner.css';

function VideoBanner() {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [isLoading, setIsLoading] = useState(true);

  // Yerel video dosyası yolu
  const videoPath = `${process.env.PUBLIC_URL}/videos/bannervideo.mp4`;

  const imagePaths = [
    `${process.env.PUBLIC_URL}/images/banner1.jpg`,
    `${process.env.PUBLIC_URL}/images/banner2.jpg`,
    `${process.env.PUBLIC_URL}/images/banner3.jpg`
  ];

  // Ekran genişliğine göre mobil/desktop kontrolü
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Video yüklendikten sonra loading'i kaldır
  const handleVideoLoad = () => {
    setIsLoading(false);
  };

  return (
    <div className="banner-container">
      {/* MOBİL GÖRÜNÜM: Yerel Video */}
      {isMobile ? (
        <>
          <div className="local-video-container">
            <video
              className="banner-video"
              autoPlay
              muted
              loop
              playsInline
              onLoadedData={handleVideoLoad}
            >
              <source src={videoPath} type="video/mp4" />
              Tarayıcınız video etiketini desteklemiyor.
            </video>
          </div>
          
          {isLoading && (
            <div className="loading-overlay">
              <div className="loading-spinner"></div>
            </div>
          )}
        </>
      ) : (
        /* MASAÜSTÜ GÖRÜNÜM: 3'lü Resim Galerisi */
        <div className="desktop-banner-grid">
          {imagePaths.map((imagePath, index) => (
            <div key={index} className="banner-grid-item">
              <img 
                src={imagePath} 
                alt={`Banner ${index + 1}`}
                className="grid-image"
                onLoad={() => index === 0 && setIsLoading(false)}
              />
              <div className="image-overlay"></div>
            </div>
          ))}
        </div>
      )}
      
      <div className="content-overlay">
        <div className="title-wrapper">
          <h1 className="main-title">HECATE</h1>
          <div className="title-divider"></div>
          <p className="subtitle">Born in a Bottle</p>
        </div>
      </div>
    </div>
  );
}

export default VideoBanner;